import { baseColors } from "./baseStyles"

export const SOIGNANT_BASE_URL = {
    ROOT: {
        staging: "https://staging-dev-soignant-api.madait-lab.com",
        preprod: "https://staging-api-ivehte.madait-lab.com"
    },
    REGISTRATION: {
        staging: "https://staging-dev-soignant-api.madait-lab.com/api/users/register",
        preprod: "https://staging-api-ivehte.madait-lab.com/api/users/register"
    },
    RESEND_ACTIVATION_CODE: {
        staging: "https://staging-dev-soignant-api.madait-lab.com/api/users/resendActivationCode",
        preprod: "https://staging-api-ivehte.madait-lab.com/api/users/resendActivationCode"
    },
    ACTIVATE_ACCOUNT: {
        staging: "https://staging-dev-soignant-api.madait-lab.com/api/users/activation",
        preprod: "https://staging-api-ivehte.madait-lab.com/api/users/activation"
    },
    FORGOT_PASSWORD: {
        staging: "https://staging-dev-soignant-api.madait-lab.com/api/users/forgotPassword",
        preprod: "https://staging-api-ivehte.madait-lab.com/api/users/forgotPassword"
    }
}

const stagingUrl = {
    providence: "https://staging-api-providence-dev.madait-lab.com",
    salutance: "https://test-cpts-salutance.madait-lab.com",
    duvalmadait: "https://api-staging-du-val.madait-lab.com"
}

export const CPTS_BASE_URL = {
    ROOT: {
        staging: "https://api-staging-du-val.madait-lab.com",
        preprod: "https://api-preprod-cpts-laprovidence.ivehte.fr:49206"
    },
    REGISTRATION: {
        staging: "https://api-staging-du-val.madait-lab.com/api/users/register",
        preprod: "https://api-preprod-cpts-laprovidence.ivehte.fr:49206/api/users/register"
    },
    RESEND_ACTIVATION_CODE: {
        staging: "https://api-staging-du-val.madait-lab.com/api/users/resendActivationCode",
        preprod: "https://api-preprod-cpts-laprovidence.ivehte.fr:49206/api/users/resendActivationCode"
    },
    ACTIVATE_ACCOUNT: {
        staging: "https://api-staging-du-val.madait-lab.com/api/users/activation",
        preprod: "https://api-preprod-cpts-laprovidence.ivehte.fr:49206/api/users/activation"
    },
    FORGOT_PASSWORD: {
        staging: "https://api-staging-du-val.madait-lab.com/api/users/forgotPassword",
        preprod: "https://api-preprod-cpts-laprovidence.ivehte.fr:49206/api/users/forgotPassword"
    }
}
export const NO_HEADER_URL = {
    REGISTRATION: "/api/users/register",
    RESEND_ACTIVATION_CODE: "/api/users/resendActivationCode",
    ACTIVATE_ACCOUNT: "/api/users/activation",
    FORGOT_PASSWORD: "/api/users/forgotPassword"
}
export const constants = {
    colors: {
        green: baseColors.green.primary,
        greenDark: baseColors.green.dark,
        greenSecondary: baseColors.green.secondary,
        greenLight: "rgba(230, 244, 244, 1)",
        black: baseColors.black,
        orangeDark: "#FF821F",
        orangePrimary: baseColors.orange.primary,
        orangeLight: "#FFF9F5",
        orangeSecondary: "#F5A15D",
        grey: "#BFC8C9"
    }
}

export const message = {
    created: (itemName) => `${itemName} crée avec succès !`,
    createdActivity: "Activité crée avec succès!",
    serverError: "oops! une erreur inconnue est survenue",
    notFound: "Données introuvables",
    updatedSuccess: "Vos modifications ont été sauvegardées",
    deletedSuccess: "Suppression réussie !"
}

export const LOGIN_ERROR = {
    NOT_ACTIVATED: "Your account is not active"
}
export const EventType = {
    INDIVIDUAL: "Individuel",
    COLLECTIF: "Collectif"
}

export const FeedbackTypes = {
    TECHNICAL_PROBLEM: "Problème technique",
    SUGGESTION: "Suggestion d'amélioration",
    OTHER: "Autre",
    QUESTION: "Question"
}

export const DiagnosisState = {
    PENDING: "pending",
    IN_PREPARATION: "in_preparation",
    IN_PROGRESS: "in_progress",
    READY: "diagnosis_ready",
    FINISHED: "diagnosis_finished"
}

export const unauthorizedDEAndFollUpDEState = [
    DiagnosisState.PENDING,
    DiagnosisState.IN_PREPARATION,
    DiagnosisState.READY
]

export const disableDECard = [DiagnosisState.PENDING, DiagnosisState.IN_PREPARATION]

export const consultationTypes = {
    PRESENTIEL: "Présentiel",
    VISIO: "Visioconférence"
}
export const EventName = {
    RDV: "Rdv",
    RDV_CONTROL: "Rdv contrôle",
    DIAGNOSTIC_EDUCATIF: "Diagnostic éducatif",
    ENTRETIEN_INDIVIDUELLE: "Entretien individuel"
}
export const mediasType = [
    {
        id: 1,
        label: "Articles",
        type: "TYPE_IMAGE"
    },
    {
        id: 2,
        label: "Vidéos",
        type: "TYPE_VIDEO"
    },
    {
        id: 3,
        label: "Autres",
        type: "TYPE_TEXT"
    }
]

export const ArticleTypes = {
    image: "TYPE_IMAGE",
    video: "TYPE_VIDEO",
    text: "TYPE_TEXT"
}

export const PostCategories = {
    knowledge: "SAVOIR",
    knowHowToBe: "SAVOIR_ETRE",
    knowHow: "SAVOIR_FAIRE"
}
export const seenHistories = [
    {
        id: 1,
        label: "Déjà vu",
        seen: true
    },
    {
        id: 2,
        label: "Jamais vu",
        seen: false
    }
]

export const arrayOfColors = [
    {
        id: 1,
        textColor: baseColors.green.dark,
        backgroundColor: baseColors.white
    },
    {
        id: 2,
        textColor: baseColors.orange.primary,
        backgroundColor: baseColors.orange.light
    }
]
export const AXIS = {
    DIETETIQUE: "Axe Diététique",
    PSYCO: "Axe Psychologique",
    APA: "Axe APA",
    MEDICAL: "Axe Médical"
}
export const topicsType = [
    {
        id: 1,
        label: "APA",
        type: "apa"
    },
    {
        id: 2,
        label: "Diététique",
        type: "dietetic"
    },
    {
        id: 3,
        label: "Psychologie",
        type: "pyschological"
    },
    {
        id: 4,
        label: "Médicaux",
        type: "medical"
    }
]

export const followedTopics = [
    {
        id: 1,
        label: "Tous",
        type: "all",
        value: 0
    },
    {
        id: 2,
        label: "Sujets en favoris",
        type: "favorite",
        value: 1
    }
]

export const diagnosticStatus = [
    {
        id: 1,
        label: "EN ATTENTE",
        status: DiagnosisState.PENDING,
        descripiton:
            "Vous avez terminé la première étape du Diagnostic Éducatif. Nous vous invitons à patienter jusqu'à votre entretien."
    },
    {
        id: 2,
        label: "EN PRÉPARATION",
        status: DiagnosisState.IN_PREPARATION,
        descripiton:
            "L’équipe thérapeutique prépare les conclusions du Diagnostic Éducatif. Vous serez notifié(e) dès que vos résultats seront prêts."
    },
    {
        id: 3,
        label: "DIAGNOSTIC PRÊT",
        status: DiagnosisState.READY,
        descripiton:
            "Votre Diagnostic Éducatif est prêt. Cliquez ici pour le consulter : vous devrez le valider ou prévoir une autre consultation en cas de désaccord."
    },
    {
        id: 4,
        label: "EN COURS",
        status: DiagnosisState.IN_PROGRESS,
        descripiton:
            "Votre Diagnostic Éducatif est en cours. Cliquez ici pour le consulter : vous devrez le valider ou prévoir une autre consultation en cas de désaccord."
    }
]

//"Minutes avant", "Heures avant", "Jours avant", "Semaines avant"
const declencheurs = [
    {
        id: 1,
        label: "Minutes avant",
        value: "minute"
    },
    {
        id: 2,
        label: "Heures avant",
        value: "hour"
    },
    {
        id: 3,
        label: "Jours avant",
        value: "day"
    },
    {
        id: 4,
        label: "Semaines avant",
        value: "week"
    }
]

//"Une seule fois","Tous les jours", "Toutes les semaine", "Toutes les mois", "Toutes les ans", "Personnalisé..."
const recurrences = [
    {
        id: 1,
        label: "Une seule fois",
        value: "once"
    },
    { id: 2, label: "Tous les jours", value: "day" },
    { id: 3, label: "Toutes les semaine", value: "week" },
    { id: 4, label: "Toutes les mois", value: "month" },
    { id: 5, label: "Toutes les ans", value: "year" },
    { id: -1, label: "Personnalisé", value: "custom" }
]

const POST_TYPE = {
    text: "TYPE_TEXT",
    video: "TYPE_VIDEO",
    image: "TYPE_IMAGE"
}

const defaultReminder = {
    patientId: null,
    name: "",
    reminderTypeId: null,
    deadline: new Date(),
    time: null,
    recurrence: {
        frequency: 1,
        frequencyUnit: "week",
        onlyRecurrenceDate: "2022-07-22 08:15",
        recurrenceDays: []
    },
    timeBefore: 10,
    timeBeforeUnit: "minute"
}
const AXIS_IDENTIFICATION = {
    APA: 1,
    DIET: 2,
    PSYCHO: 3,
    MEDICAL: 4
}

const ConsentItems = [
    {
        id: 1,
        label: "Procédure de l'étude",
        value: "Vous serez interrogé au cours d’un entretien téléphonique, pendant environ 15 minutes, afin de réaliser notre travail de recherche visant à mieux comprendre les facteurs influençant l’adhésion des patients au programme SALUTANCE que vous vous apprêtez à suivre. Cette étude a fait l’objet de formalités déclaratives règlementaires pour la protection des données personnelles auprès du délégué à la protection des données à caractère personnel (DPO) de l’Université et d’une soumission au comité d’éthique national du Collège National des Généralistes Enseignants (CNGE)."
    },
    {
        id: 2,
        label: "Destinataires des données collectées",
        value: `Coordinateur de la recherche : Dr Emile ESCOURROU et Dr Laëtitia GIMENEZ (Médecin généraliste)`,
        subContent:
            "Investigateur et responsable du traitement des données : Dr Florent PORTET (Médecin généraliste, étudiant en Master 2 Epidémiologie Clinique)"
    },
    {
        id: 3,
        label: "Risques potentiels de l’étude",
        value: "L’étude ne présente aucun risque : aucun geste technique n’est pratiqué, ni de test thérapeutique. Vous pouvez mettre fin à l’entretien à tout moment."
    },
    {
        id: 4,
        label: "Bénéfices potentiels de l’étude",
        value: "Cette étude permettra d’identifier les déterminants de l’adhésion au programme SALUTANCE et ainsi de réaliser les modifications nécessaires afin d’en optimiser son efficacité."
    },
    {
        id: 5,
        label: "Participation volontaire",
        value: "Votre participation à cette étude est entièrement volontaire. Il n’y a aucun caractère obligatoire. Vous avez le droit de retirer votre consentement à tout moment sans encourir aucune responsabilité ni aucun préjudice de ce fait."
    },
    {
        id: 6,
        label: "Droits des participants",
        value: "Vous avez un droit d’accès, de rectification, un droit à l’effacement et à la limitation du traitement, ainsi qu’à la portabilité des données vous concernant, à tout moment sur simple demande auprès de l’investigateur de l’étude. Vous avez également le droit de faire une réclamation auprès de la Commission Nationale de l’Informatique et des Libertés (CNIL), autorité de contrôle en charge du respect des obligations en matière de données à caractère personnel."
    },
    {
        id: 8,
        label: "Durée de conservation des données",
        value: "Les données à caractère personnel seront conservées jusqu’à 2 ans après la publication du travail de recherche et seront définitivement supprimées par la suite."
    },
    ,
    {
        id: 9,
        label: "Confidentialité et utilisation des données médicales ou personnelles",
        value: "Dans le cadre de l’étude à laquelle Dr Florent PORTET vous propose de participer, vos données personnelles feront l’objet d’un traitement, afin de pouvoir les inclure dans l’analyse des résultats de la recherche. Il s’agit des données concernant vos caractéristiques sociodémographiques, vos habitudes de vie et votre état de santé mental et physique. Ces données seront pseudonymisées et leur identification anonymisées.Dans le cadre de l’étude à laquelle Dr Florent PORTET vous propose de participer, vos données personnelles feront l’objet d’un traitement, afin de pouvoir les inclure dans l’analyse des résultats de la recherche. Il s’agit des données concernant vos caractéristiques sociodémographiques, vos habitudes de vie et votre état de santé mental et physique. Ces données seront pseudonymisées et leur identification anonymisées."
    },
    {
        id: 10,
        label: "Coordonnées des personnes à contacter pour obtenir des renseignements complémentaires ou pour exercer vos droits",
        value: "Vous pouvez faire appel au Dr Florent PORTET par mail drflorentportet@gmail.com ou par courrier à son attention au DUMG de Toulouse, 133 ROUTE DE NARBONNE, 31062 TOULOUSE, ou bien auprès du Délégué à la protection des données, Pr. Pierre Boyer DUMG de Toulouse, 133 ROUTE DE NARBONNE, 31062 TOULOUSE, ou par mail à l’adresse dpo@dumg-toulouse.fr."
    }
]

const REFECTH_QUERY_INTERVAL = 2500

export {
    REFECTH_QUERY_INTERVAL,
    ConsentItems,
    AXIS_IDENTIFICATION,
    declencheurs,
    recurrences,
    defaultReminder,
    POST_TYPE
}
